<template>
  <main id="main-content" class="flex-grow flex items-center justify-center bg-white py-12 md:py-20 min-h-[70vh]">
    <div class="max-w-3xl mx-auto px-4 text-center flex flex-col items-center">

      <img src="../../../assets/imagens/404.jpg" alt="Imóvel não encontrado" class="w-full max-w-md mx-auto mb-8 object-contain" />

      <div class="mb-10">
        <h1 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4 tracking-tight">
          Oops! <span class="text-marca-secundaria">Página não encontrada</span>
        </h1>
        <p class="text-gray-500 text-base md:text-lg max-w-xl mx-auto">
          O imóvel ou a página que você está procurando não está mais disponível em nosso sistema.
        </p>
      </div>

      <button @click="voltar" class="btn-voltar-home inline-flex items-center justify-center gap-2">
        <i class="ph ph-arrow-left text-xl"></i> Voltar para Página Inicial
      </button>

    </div>
  </main>
</template>

<script>
export default {
  methods: {
    voltar() {
      this.$router.replace('/');
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../sass/settings.scss';

.text-marca-secundaria {
    color: $main-color-hover !important;
}

.btn-voltar-home {
    background-color: $main-color !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    padding: 0.875rem 2rem !important;
    border-radius: 0.75rem !important;
    transition: all 0.3s ease !important;
    border: none !important;
    cursor: pointer !important;
    font-family: 'Inter', sans-serif !important;

    &:hover {
        background-color: $main-color-hover !important;
        transform: translateY(-2px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
    }
}
</style>